<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.customerSettlements'),
          $t('action.intelligentCheck'),
        ]"
      >
      </breadcrumb>
    </div>
    <div class="wrapper table-area" style="padding: 20px">
      <el-form
        ref="settlementForm"
        :model="settlement"
        class="box"
        label-width="110px"
      >
        <fieldset>
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('settlement.title')">{{
                settlement.title
              }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('menu.customers')">{{
                settlement.customerName
              }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('settlement.direction')">{{
                $t("settlement.directionsCustomer." + settlement.settleType)
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col v-if="settlement.selfVerifyAt != null" :span="8">
              <el-form-item :label="$t('settlement.selfVerifyAt')">{{
                settlement.selfVerifyAt
              }}</el-form-item>
            </el-col>

            <el-col v-if="settlement.verifyAt != null" :span="8">
              <el-form-item :label="$t('settlement.verifyAt')">{{
                settlement.verifyAt
              }}</el-form-item>
            </el-col>
            <el-col v-if="settlement.payoffAt != null" :span="8">
              <el-form-item :label="$t('settlement.receiveoffAt')">{{
                settlement.payoffAt
              }}</el-form-item>
            </el-col>
          </el-row>
          <div class="search-condition-div">
            {{ $t("settlement.searchCondition") }}:{{
              settlement.searchCondition
            }}
          </div>
          <div class="font8 orange" v-if="settlement.settleType == 'Purchase'">
            *下单日期 对应 我的订单项 创建日期<br />
            *收货完成日期 对应 我的订单项 客户收货日期<br />
            *供应商发货完成日期 对应 我的订单项 交货完成日期
          </div>
        </fieldset>
      </el-form>

      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <span class="font10">
              <div class="float-left color-explain bg-yellow font10"></div>
              <div class="float-left mgr5 mgt5 font10">
                查询条件内未结算的订单
              </div>
              <div class="float-left color-explain bg-red font10"></div>
              <div class="float-left mgr5 mgt5 font10">
                结算金额和订单小计不一致
              </div>
            </span>
            <el-button
              v-if="
                settlement &&
                settlement.verifyAt == null &&
                settlement.settleType == 'Purchase'
              "
              type="primary"
              size="mini"
              @click="verify"
              class="float-right"
            >
              {{ $t("action.otherVerify") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="newOrders"
        border
        size="small"
        :loading="loading"
        class="recordsTable"
        ref="recordsTable"
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
        :row-class-name="calculateBgColor"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div>
              <state-label
                :state="row.workflowState"
                :permit="Permit.canActions('orderDealView')"
              >
                <span v-if="Permit.canActions('orderDealView')">
                  {{ $t("orderStates." + row.workflowState) }}
                </span>
                <span v-else>
                  {{ $t("orderStatesNoPermit." + row.workflowState) }}
                </span>
              </state-label>
            </div>
            <div
              class="orange font10"
              v-if="
                row.settlementId != null && row.settlementId != settlement.id
              "
            >
              其他账单
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="80"
          sortable
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="80"
          sortable
        />
        <vxe-table-column
          field="finishAt"
          :title="$t('order.finishAt')"
          min-width="80"
          sortable
        />

        <vxe-table-colgroup title="我的订单">
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}{{ row.unit }}
              <div class="font10">
                {{ $t("order.price") }}:
                <currency :code="row.currency"></currency>
                {{ row.price }}
              </div>
              <div
                v-if="row.extraCharge != null && row.extraCharge != 0"
                class="font10"
              >
                {{ $t("order.extraCharge") }}:
                <currency :code="row.currency"></currency>
                {{ row.extraCharge }}
              </div>
              <div
                class="font10"
                v-if="row.quotedPrice != null && row.quotedPrice != ''"
              >
                {{ $t("product.quotation") }}:
                <currency :code="row.currency"></currency>{{ row.quotedPrice }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('order.subtotal')" min-width="80">
            <template v-slot="{ row }">
              <currency :code="row.currency"></currency>
              {{ row.price * row.quantity + row.extraCharge }}
            </template>
          </vxe-table-column>
        </vxe-table-colgroup>
        <vxe-table-colgroup title="账单信息">
          <vxe-table-column :title="$t('text.quantity')" min-width="80">
            <template v-slot="{ row }">
              <span
                v-if="row.orderSettlement && row.orderSettlement.order != null"
              >
                {{ row.orderSettlement.order.quantity
                }}{{ row.orderSettlement.order.unit }}
                <div class="font10">
                  {{ $t("order.price") }}:
                  <currency
                    :code="row.orderSettlement.order.currency"
                  ></currency>
                  {{ row.orderSettlement.order.price }}
                </div>
                <div
                  v-if="
                    row.orderSettlement.order.extraCharge != null &&
                    row.orderSettlement.order.extraCharge != 0
                  "
                  class="font10"
                >
                  {{ $t("order.extraCharge") }}:
                  <currency
                    :code="row.orderSettlement.order.currency"
                  ></currency>
                  {{ row.orderSettlement.order.extraCharge }}
                </div>
                <div
                  class="font10"
                  v-if="
                    row.orderSettlement.order.quotedPrice != null &&
                    row.orderSettlement.order.quotedPrice != ''
                  "
                >
                  {{ $t("product.quotation") }}:
                  <currency
                    :code="row.orderSettlement.order.currency"
                  ></currency
                  >{{ row.orderSettlement.order.quotedPrice }}
                </div>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('order.subtotal')" min-width="80">
            <template v-slot="{ row }">
              <span
                v-if="row.orderSettlement && row.orderSettlement.order != null"
              >
                <currency :code="row.orderSettlement.order.currency"></currency>
                {{
                  row.orderSettlement.order.price *
                    row.orderSettlement.order.quantity +
                  row.orderSettlement.order.extraCharge
                }}
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            :title="$t('settlement.settleTotal')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <span v-if="row.orderSettlement != null">
                <currency
                  :code="row.orderSettlement.order.currency"
                  v-if="
                    row.orderSettlement &&
                    row.orderSettlement.order &&
                    row.orderSettlement.order != null
                  "
                ></currency>
                {{ row.orderSettlement.settleTotal }}
                <div class="font10">
                  <raw-html-limit-number
                    :content="row.orderSettlement.explain"
                    :number="8"
                  />
                </div>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            :title="$t('settlement.selfVerifyAt')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span v-if="row.orderSettlement != null">
                {{ row.orderSettlement.selfVerifyAt }}
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('settlement.verifyAt')" min-width="100">
            <template v-slot="{ row, rowIndex }">
              <span v-if="row.orderSettlement != null">
                {{ row.orderSettlement.verifyAt }}
                <div class="font10">
                  <i
                    v-if="
                      row.orderSettlement.verifyAt == null &&
                      settlement.settleType == 'Purchase'
                    "
                    slot="reference"
                    class="el-icon-edit fl"
                    @click="editVerifyExplain(row, rowIndex)"
                  />
                  <raw-html-limit-number
                    :content="row.orderSettlement.verifyExplain"
                    :number="8"
                  />
                </div>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button
                v-if="
                  row.orderSettlement &&
                  settlement.settleType == 'Purchase' &&
                  row.orderSettlement.verifyAt == null
                "
                size="mini"
                type="text"
                @click="verifyItem(row, rowIndex)"
                >{{ $t("action.otherVerify") }}</el-button
              >
            </template>
          </vxe-table-column>
        </vxe-table-colgroup>
      </vxe-table>
    </div>

    <!-- 编辑对账说明 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('settlement.verifyExplain')])"
      :close-on-click-modal="false"
      :visible.sync="editVerifyExplainDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editVerifyExplainObj.verifyExplain"
          type="textarea"
          :rows="2"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editVerifyExplainDoing"
          size="small"
          @click="editVerifyExplainSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editVerifyExplainDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";

import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import Currency from "@/components/Currency";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Settlement from "@/api/settlement.js";

export default {
  mixins: [page],
  components: {
    Currency,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      settlement: { id: null },
      items: [],
      orders: [],
      newOrders: [],
      loading: false,
      //
      //编辑对账说明
      row: null,
      rowIndex: null,
      editVerifyExplainDF: false,
      editVerifyExplainObj: {
        verifyExplain: null,
      },
      editVerifyExplainDoing: false,
    };
  },

  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    // 核对
    verify() {
      const self = this;
      Settlement.verify(self.settlement.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.$router.push({ name: "fnReportsCustomerSettlements" });
        } else {
          self.sysError();
        }
      });
    },
    // 核对账单明细
    verifyItem(row, rowIndex) {
      const self = this;
      Settlement.verifyItem(self.settlement.id, row.orderSettlement.id).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.verifySuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        }
      );
    },
    // 编辑对账说明
    editVerifyExplain(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editVerifyExplainObj.verifyExplain =
        row.orderSettlement.verifyExplain;
      this.editVerifyExplainDoing = false;
      this.editVerifyExplainDF = true;
    },
    editVerifyExplainSubmit() {
      const self = this;
      self.editVerifyExplainDoing = true;
      Settlement.updateVerifyExplain(
        self.settlement.id,
        self.row.orderSettlement.id,
        self.editVerifyExplainObj
      ).then(function (res) {
        self.editVerifyExplainDoing = false;
        self.editVerifyExplainDF = false;
        if (res.status === 200) {
          self.newOrders[self.rowIndex].orderSettlement.verifyExplain =
            self.editVerifyExplainObj.verifyExplain;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    //
    loadData() {
      const self = this;
      self.loading = true;
      axios
        .all([
          Settlement.findById(self.$route.params.id),
          Settlement.items(self.$route.params.id, { type: "Order" }),
          Settlement.orderChecking(self.$route.params.id),
        ])
        .then(
          axios.spread(function (settlement, items, orders) {
            self.settlement = settlement.data;
            self.items = items.data;
            self.orders = orders.data;
            self.newOrders = [];
            if (self.orders.length != 0) {
              for (const order of self.orders) {
                if (
                  self.items.find((i) => i.recordUuid == order.uuid) != null
                ) {
                  Vue.set(
                    order,
                    "orderSettlement",
                    self.items.find((i) => i.recordUuid == order.uuid)
                  );
                }
                self.newOrders.push(order);
              }
            }
            self.loading = false;
          })
        );
    },
    calculateBgColor({ row, rowIndex }) {
      if (row.orderSettlement && row.orderSettlement != null) {
        if (
          row.orderSettlement.settleTotal !=
          row.orderSettlement.order.price * row.orderSettlement.order.quantity +
            row.orderSettlement.order.extraCharge
        ) {
          return "red-bg";
        }
        return "";
      }
      return "yellow-bg";
    },
  },
};
</script>
<style>
.color-explain {
  height: 10px;
  width: 40px;
  border: 1px solid #eee;
  margin-top: 7px;
  margin-right: 5px;
}
.bg-yellow {
  background: #fff2b7;
  color: #fff;
}
.bg-red {
  background: rgb(248, 128, 128);
  color: #fff;
}
.recordsTable .yellow-bg {
  background: #fff2b7;
}
.recordsTable .red-bg {
  background: rgb(248, 128, 128);
}
</style>
